import React from 'react';
import { Col, Management, Row } from 'components';
import { ManagementEditModal } from './edit';
import { useManagement } from './useManagement';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';

export const CountryManagement = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { onAddModalStateChange, managementData, modalState } = useManagement();
  return (
    <Row wrap={false}>
      <Col flex={'566px'}>
        <HasAccess role={PERMISSIONS.countries.management.read}>
          <Management
            hasAccessToEdit={hasAccess(PERMISSIONS.countries.management.write)}
            managementData={managementData}
            onAddModalStateChange={onAddModalStateChange}
          />
        </HasAccess>
      </Col>
      <ManagementEditModal modalState={modalState} onModalStateChange={onAddModalStateChange} />
    </Row>
  );
});
